import React from 'react';
import PropTypes from 'prop-types';
import LegalLink from '../../Atoms/LegalLink';
import FooterMenu from '../../Atoms/FooterMenu';
import { testAttributes, disclosureContent, copyRight as copyRightDefault } from './Constants';
import { compProps as footerMenu } from '../../Atoms/FooterMenu/Constants';
import { compProps as legalLinkMenu } from '../../Atoms/LegalLink/Constants';
import {footerContent, footerContainer, footerDisclosure, menu} from './Footer.module.scss';

const Footer = ({
    menuItems = footerMenu,
    legaleseMenu = legalLinkMenu,
    disclosure = disclosureContent,
    copyRight = copyRightDefault
}) => (
    <footer
        data-testid={testAttributes.FOOTER_CONTAINER}
        className={`${footerContainer} QLD_ROOT`}
    >
        <div className="qld-grid" data-testid={testAttributes.FOOTER_WRAPPER}>
            <div className={`qld-row ${menu}`} data-testid={testAttributes.FOOTER_MENU}>
                <FooterMenu menuItems={menuItems} />
            </div>
            <div className={`qld-row ${footerContent}`}>
                <div data-testid={testAttributes.FOOTER_DISCLOSURE} className={footerDisclosure}>
                    {disclosure}
                </div>
                <LegalLink legaleseMenu={legaleseMenu} />
                <div data-testid={testAttributes.FOOTER_COPYRIGHT}>
                    <p>{copyRight}</p>
                </div>
            </div>
        </div>

    </footer>
);
Footer.propTypes = {
    /** Footer menu columns with links */
    menuItems: PropTypes.array,
    /** legaleseMenu: List of menu items */
    legaleseMenu: PropTypes.array,
    /** Disclosure:  Quicken Loans Legal information */
    disclosure: PropTypes.array,
    /** Copy Right:  Company copy rights */
    copyRight: PropTypes.array,
};

export default Footer;
